var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white",class:{ 'nav-open': _vm.$sidebar.showSidebar },style:([_vm.baseStyles])},[_c('notifications'),_c('router-view'),(_vm.logged())?_c('bottom-navbar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }